export default class modalImportCtrl {
  constructor($scope, $uibModalInstance, items1, httpRequest) {
    $scope.modaldata = items1;
    // 导出操作
    // 导入
    // 错误信息页脚分页参数
    $scope.pageModalImportOpt = {
      totalItems: $scope.modaldata.params.data.total, // 组件初始化设置总页数
      currentPage: ++$scope.modaldata.params.data.prePage, // 设置显示第一页
      maxSize: $scope.modaldata.params.data.pageSize, // 每一叶显示记录数
    };
    // 页码操作
    $scope.pageModalImportChanged = function () {
      const _req = {
        pageNum: $scope.pageModalImportOpt.currentPage,
        pageSize: $scope.pageModalImportOpt.maxSize,
        param: $scope.modaldata.params.batchNo,
      };
      httpRequest.post_getPageDlBatchInfoList(_req).then((res) => {
        $scope.modaldata.params.data = res.data.value;
        $scope.pageModalImportOpt = {
          totalItems: $scope.modaldata.params.data.total, // 组件初始化设置总页数
          currentPage: ++$scope.modaldata.params.data.prePage, // 设置显示第一页
          maxSize: $scope.modaldata.params.data.pageSize, // 每一叶显示记录数
        };
      });
    };
    // 关闭
    $scope.cancelModalImport = function () {
      $uibModalInstance.dismiss("cancel");
    };
    // 确定
    $scope.downBatchInfo = function (v) {
      // 返回数据
      const _res = {
        params: {},
      };
      window.open(
        `${host.etcloud}dl/dlTaskService/downBatchInfoDetail?batchNo=${v}&accessToken=${$scope.modaldata.idToken}`
      );
      $uibModalInstance.close(_res);
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/importexcel/modalImportCtrl.js